import React, { useState, useEffect } from 'react';

const EditModal = ({ record, onClose, onSave }) => {
  const [formData, setFormData] = useState({ verified: '' });

  useEffect(() => {
    if (record) {
      setFormData({
        verified: record.verified || 'not-verified.jpg'
      });
    }
  }, [record]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave({
      ...record, // Keep all original data
      verified: formData.verified // Only update verified field
    });
  };

  if (!record) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg w-full max-w-md">
        <h2 className="text-xl font-bold mb-4">Update Verification Status</h2>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Verification Status
            </label>
            <select
              name="verified"
              value={formData.verified}
              onChange={handleChange}
              className="mt-1 block w-full border border-gray-300 rounded-md p-2"
            >
              <option value="verified.jpg">Verified</option>
              <option value="not-verified.jpg">Not Verified</option>
            </select>
          </div>
          
          <div className="flex justify-end space-x-2 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-md"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
            >
              Update Status
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditModal;